import axios from 'axios';

export const handleApiRequest = async (url, type, payload, isAuthReq) => {
  const baseUrl = 'https://backend.rogerops.com/';
  if (isAuthReq) {
    axios.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem('auth_token');
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );
  }

  try {
    if (type === 'get') {
      return axios.get(`${baseUrl}${url}`);
    }
    if (type === 'post') {
      return axios.post(`${baseUrl}${url}`, payload);
    }
  } catch (error) {
    return error;
  }
};
